import { useEffect, type CSSProperties } from 'react';

export function FinaleShortcutUnlock({ onComplete }: { onComplete: () => void }) {
  useEffect(() => {
    const timer = window.setTimeout(onComplete, 3400);
    return () => window.clearTimeout(timer);
  }, [onComplete]);

  return (
    <aside className="finale-shortcut" role="status" aria-live="assertive">
      <div className="finale-shortcut__portal" aria-hidden="true">
        {Array.from({ length: 18 }, (_, index) => <i key={index} style={{ '--portal-mark': index } as CSSProperties} />)}
      </div>
      <div className="finale-shortcut__copy">
        <p>CABINET BACKDOOR // ISLAND ZERO</p>
        <strong>SHORTCUT ACHIEVED</strong>
        <span>The left slot exposed a buried service key. Twenty right-slot pulses forced the Convergence relay to answer.</span>
        <b>FINAL SIGNAL ACQUIRED // ENTERING THE LAST TRANSMISSION</b>
      </div>
    </aside>
  );
}
